import { createSlice } from "@reduxjs/toolkit"

import packageJson from "../../../package.json"

export const localStorageSlice = createSlice({
  name: "localStorage",
  initialState: window.localStorage.getItem(packageJson.name)
    ? JSON.parse(window.localStorage.getItem(packageJson.name))
    : {},
  reducers: {
    add: (state, action) => {
      const { key, value } = action.payload
      state[key] = value
      window.localStorage.setItem(packageJson.name, JSON.stringify(state))
    },
    clear: (state) => {
      state = {}
      window.localStorage.removeItem(packageJson.name)
    },
    remove: (state, action) => {
      delete state[action.payload.key]
      window.localStorage.setItem(packageJson.name, JSON.stringify(state))
    }
  }
})

export const { add: addLocalStorage, remove: removeLocalStorage, clear: clearLocalStorage } = localStorageSlice.actions

export default localStorageSlice.reducer